import {register} from '../../../assets/js/modules/eventMap';

const init = (el) => {
    const form = el.form;

    if (!form) {
        return;
    }

    const hook = 'data-kinde-is-invalid-control-focussed';

    if (!form.getAttribute(hook)) {
        const invalidControls = form.querySelectorAll('[aria-invalid="true"]');
        const firstInvalidControl = invalidControls[0];

        // Set a flag so it only runs once
        form.setAttribute(hook, 'true');

        firstInvalidControl.focus({focusVisible: true});
    }
};

const focusInvalidControl = () => {
    register('focusInvalidControl', {init});
};

export {focusInvalidControl};
